import './header.css';
import logo from '../../assets/img/png/logo.png';
import logoWhite from '../../assets/img/png/logo_white.png';
import userImg from '../../assets/img/jpg/user.jpg';
import { forwardRef, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLang } from '../../context/LangContext';

export const Header = forwardRef((props, ref) => {
    const {
        isAuth,
        user,
        logout,
        checkAuth
    } = useAuth();

    const { lang, setLangEn, setLangEs } = useLang();
    const navigate = useNavigate();

    //REFS
    const userDropdownRef = useRef();

    //STATES
    const [userDropdownActive, setUserDropdownActive] = useState(false);
    const [responsiveToggle, setResponsiveToggle] = useState(false);

    //FUNCTIONS
    const toggleUserDropdown = () => {
        setUserDropdownActive((prev) => !prev);
    }

    const log_out = () => {
        logout((res) => {
            checkAuth();
            navigate('/', {replace: true});
        });
    }

    //EFFECTS
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                userDropdownRef.current &&
                !userDropdownRef.current.contains(event.target)
            ) {
                setUserDropdownActive(false);
            }
        };
    
        if (userDropdownActive) {
          window.addEventListener('click', handleClickOutside);
        } else {
          window.removeEventListener('click', handleClickOutside);
        }
    
        return () => {
          window.removeEventListener('click', handleClickOutside);
        };
      }, [userDropdownActive]);

    return (
        <>
            <div className='social_header'>
                <a href='https://www.facebook.com/john.hanley.phd/' target='_blank' rel='noreferrer'>
                    <i className="fa-brands fa-facebook-f"></i>
                </a>
                <a href='https://www.instagram.com/quantumhanley/' target='_blank' rel='noreferrer'>
                    <i className="fa-brands fa-instagram"></i>
                </a>
                <a href='https://twitter.com/quantumhanley' target='_blank' rel='noreferrer'>
                    <i className="fa-brands fa-x-twitter"></i>
                </a>
                <a href='https://www.youtube.com/channel/UC42bwsFlp2_PL-plx--i61g' target='_blank' rel='noreferrer'>
                    <i className="fa-brands fa-youtube"></i>
                </a>
                <a href='https://www.linkedin.com/company/quantumhanley111' target='_blank' rel='noreferrer'>
                    <i className="fa-brands fa-linkedin-in"></i>
                </a>
                <a href='https://www.google.com/search?q=john+hanley+phd&rlz=1C1ONGR_esCO998CO998&oq=&gs_lcrp=EgZjaHJvbWUqBggBEEUYOzIGCAAQRRg5MgYIARBFGDsyBggCECMYJzIHCAMQLhiABDIHCAQQLhiABDIHCAUQABiABDIHCAYQLhiABDIHCAcQLhiABDIJCAgQABgKGIAEMgcICRAuGIAE0gEIMTk1MGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8' target='_blank' rel='noreferrer'>
                    <i className="fa-solid fa-store"></i>
                </a>
            </div>
            <header>
                <div className='links_group1'>
                    <Link to='/' className='logo'>
                        <img src={logo} alt='' />
                    </Link>
                </div>
                <div className='links_group2'>
                    <Link to='/'>
                        { lang === "en" ? "HOME" : "INICIO" }
                    </Link>
                    <Link to='/courses'>
                        { lang === "en" ? "ACADEMIES" : "ACADEMIAS"}
                    </Link>
                    <Link to='/contact'>
                        { lang === "en" ? "CONTACT" : "CONTACTO"}
                    </Link>
                    {
                        lang === "en" ? (
                            <>
                                <button className='lang_btn' onClick={setLangEs}>
                                    Español
                                </button>
                            </>
                        ) : (
                            <>
                                <button className='lang_btn' onClick={setLangEn}>
                                    English
                                </button>
                            </>
                        )
                    }
                    {isAuth !== null && isAuth === false &&
                        (
                            <Link to='/login' className='login_btn'>
                                { lang === "en" ? "Login" : "INICIA SESIÓN" }
                            </Link>
                        )
                    }

                    {isAuth !== null && isAuth === true && user &&
                        (
                            <div className='user_container' ref={userDropdownRef}>
                                <div className='user_info' onClick={toggleUserDropdown}>
                                    <span>
                                        {user.name}
                                    </span>
                                    <i className="fa-solid fa-chevron-down"></i>
                                    <div className='profile_pic'>
                                        <img src={userImg} alt='' />
                                    </div>
                                </div>
                                <div className={userDropdownActive ? 'dropdown_container active' : 'dropdown_container'}>
                                    <Link to='/profile' onClick={() => setUserDropdownActive(false)}>
                                        { lang === "en" ? "My profile" : "Mi perfil"}
                                    </Link>
                                    <Link to='/courses' onClick={() => setUserDropdownActive(false)}>
                                        { lang === "en" ? "My Academies" : "Mis Academias"}
                                    </Link>
                                    <button onClick={log_out}>
                                        { lang === "en" ? "Logout" : "Cerrar sesión"}  
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </header>

            <div className='responsive_header'>
                <Link to='/' className='logo'>
                    <img src={logo} alt='' />
                </Link>
            </div>

            <div className={responsiveToggle ? 'responsive_menu_bk active' : 'responsive_menu_bk'} onClick={() => setResponsiveToggle(prev => !prev)}>

            </div>
            <div className={responsiveToggle ? 'responsive_menu active' : 'responsive_menu'}>
                <div className='toggle' onClick={() => setResponsiveToggle(prev => !prev)}>
                    <i className="fa-solid fa-bars"></i>
                </div>
                <Link className='logo'>
                    <img src={logoWhite} alt='' />
                </Link>
                <Link to='/' className='item'>
                    { lang === "en" ? "HOME" : "INICIO" }
                </Link>
                <Link to='/courses' className='item'>
                    { lang === "en" ? "ACADEMIES" : "ACADEMIAS"}
                </Link>
                <Link className='item' to='/contact'>
                    { lang === "en" ? "CONTACT" : "CONTACTO"}
                </Link>
                {
                    lang === "en" ? (
                        <>
                            <p className='item lang_btn' onClick={setLangEs}>
                                ESPAÑOL
                            </p>
                         </>
                    ) : (
                        <>
                            <p className='item lang_btn' onClick={setLangEn}>
                                ENGLISH
                            </p>
                        </>
                    )
                }


                {isAuth !== null && isAuth === false &&
                    (
                        <Link to='/login' className='item'>
                            { lang === "en" ? "Login" : "INICIA SESIÓN" }
                        </Link>
                    )
                }

                {isAuth !== null && isAuth === true && user &&
                    (
                        <>
                            <Link to='/profile' className='item' onClick={() => setResponsiveToggle(prev => !prev)}>
                                { lang === "en" ? "My profile" : "Mi perfil"}
                            </Link>
                            <Link to='/courses' className='item' onClick={() => setResponsiveToggle(prev => !prev)}>
                                { lang === "en" ? "My Academies" : "Mis Academias"}
                            </Link>
                            <Link className='item' onClick={() => {setResponsiveToggle(prev => !prev); log_out()}}>
                                { lang === "en" ? "Logout" : "Cerrar sesión"}
                            </Link>
                        </>
                    )
                }
            </div>
        </>
    );
});